import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

const NameInput = ({ name, setName }) => {
  const langToggle = useLanguage;
  return (
    <div className="free__form-input__wrapper form-animate">
      <label className="free__form-label">{langToggle("Ім'я:", 'Имя:')}</label>
      <input
        type="text"
        placeholder={langToggle("Введіть ваше ім'я ", 'Введите ваше имя')}
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
    </div>
  );
};

NameInput.propTypes = {
  name: PropTypes.string,
  setName: PropTypes.func,
};

export default NameInput;
